var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgF1ModeShortAbsence(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62 31.17v21.75H29V46c.166.01.334.01.5 0 2.31 0 4.5-1.77 4.5-4V30a5.55 5.55 0 00-1.43-3.2l12.93-9.06L62 31.17zM19.9 24a3 3 0 004.2.34c.122-.1.233-.215.33-.34a3 3 0 10-4.55 0h.02zM31 41.5V31a4 4 0 00-.8-2.39A3.999 3.999 0 0027 27H17a4 4 0 00-4 4v10.5a1.5 1.5 0 003 0V31a1 1 0 011-1h1v27.5a1.5 1.5 0 103 0V45h2v12.5a1.5 1.5 0 103 0V30h1a1.08 1.08 0 011 1v10.5a1.5 1.5 0 003 0z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/F1_Mode_short_absence.8449ba50.svg";
export { SvgF1ModeShortAbsence as ReactComponent };